import { IntlProvider as IntlProviderComp } from 'react-intl'
import React, { ComponentType, ReactNode } from 'react'
import { messagesSource } from 'src/i18n/texts'
import { useStoreValue } from '@core'
import { AppContext } from 'src/context/AppContext'

export const I18nProvider: ComponentType<{
    ctx: AppContext
    children: ReactNode
}> = ({ children, ctx }) => {
    const lang = useStoreValue(ctx.i18n.language)
    const resolvedLang = messagesSource[lang.toLowerCase()]
        ? lang
        : ctx.config.defaultLocale
    const messages = messagesSource[resolvedLang.toLowerCase()]
    if (!messages)
        throw new Error(
            `No messages found in source for locale '${resolvedLang}'`
        )

    // TODO locale is same as Lang ??
    return (
        <IntlProviderComp locale={resolvedLang} messages={messages}>
            {children}
        </IntlProviderComp>
    )
}
